import { FC } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useIntl } from 'react-intl';

import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { FirmwareMessages } from 'src/intl/FirmwareMessages';
import FirmwareGrid from 'src/components/firmware/FirmwareGrid';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

const FirmwareListPage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(FirmwareMessages.firmware);
  useGA4();

  const intl = useIntl();

  return (
    <IonPage>
      <DesktopHeader title={intl.formatMessage(FirmwareMessages.firmware)} />
      <IonContent>
        <FirmwareGrid />
      </IonContent>
    </IonPage>
  );
};

export default FirmwareListPage;
